import { Box, styled } from "@mui/material";

export const BoxDetailContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingLeft: theme.spacing(2),
    gap: theme.spacing(1),

    [theme.breakpoints.up("md")]: {
        paddingLeft: theme.spacing(2),
    },
}));

export const BoxContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(2),
}));
